import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import colors from '@general/colors';
import CartSummary from '../CartSummary';

const ContainerStyled = styled.div`
    background-color: ${colors.ultraLighterGray};
    border-top: 2px solid ${colors.azure};
    padding: 24px 24px 30px 24px;
`;

const CartSummarySidebar = ({ hideDiscountsSection, setCartHasErrors }) => {
    return (
        <ContainerStyled>
            <CartSummary setCartHasErrors={setCartHasErrors} hideDiscountsSection={hideDiscountsSection} />
        </ContainerStyled>
    );
};

CartSummarySidebar.propTypes = {
    setCartHasErrors: PropTypes.func,
    hideDiscountsSection: PropTypes.bool,
};

export default CartSummarySidebar;
